import { environment } from '@env/environment';

export interface AppDownloadLinks {
  ios: string;
  android: string;
}

const FLEET_APP: AppDownloadLinks = {
  ios: 'https://apps.apple.com/eg/app/madar-fleet-driver/id1578199713',
  android: 'https://play.google.com/store/apps/details?id=com.ods.madar.fleet',
};

const CUSTOMER_APP: AppDownloadLinks = {
  ios: 'https://apps.apple.com/eg/app/madar-customer/id6443457105',
  android: 'https://play.google.com/store/apps/details?id=com.madar.customer',
};

/** The fleet portal is the only tenant on its own domain. */
export const isFleetHost = (): boolean => environment.fleetHostNames.includes(window.location.hostname);

/** Fleet has its own domain; customer and TGA both ship the customer app. */
export const appDownloadLinks = (): AppDownloadLinks => (isFleetHost() ? FLEET_APP : CUSTOMER_APP);
